import sliceCreator from '../../index.jsx';
import {UPDATE_POST_SEASON_ACTIVITY} from '../../../constants/index.jsx';
const _updatePostSeasonActivityAction = sliceCreator('UPDATE_POST_SEASON_ACTIVITY', UPDATE_POST_SEASON_ACTIVITY, 'put');

const { asyncAction: updatePostSeasonActivityAction, reducer, clearData: clearUpdatePostSeasonActivityAction } = _updatePostSeasonActivityAction;

export default reducer;

export {
    updatePostSeasonActivityAction,
    clearUpdatePostSeasonActivityAction
}